<app-patient-info [heading]="Item"></app-patient-info>


<div class="col-12 " [hidden]="activatedRoute.children.length > 0">
    <div class="formgroup-inline col-12 pb-0 card">

        <div class="field col-5 pb-0 pt-1">
            <label htmlfor="txtAllergySerach" class="p-sr-only">Enter your search</label>
            <input pinputtext=""
                   id="txtAllergySerach"
                   type="text"
                   placeholder="Enter your search"
                   class="text-base text-color p-2 w-12"
                   [(ngModel)]="txtSearch"
                   style="width: auto; height: 37px" />
        </div>
        <div class="pb-0 pt-1 BH">
            &nbsp;
            <button pButton
                    type="button"
                    icon="pi pi-search"
                    label="Search"
                    (click)="SearchDocumentDetails()"
                    class="loginbtn"></button>
            &nbsp;<p-button label="Clear" severity="secondary" icon="pi pi-refresh" (click)="clearSearch()">
            </p-button>
            &nbsp;

        </div>
    </div>
        <p-table #dt
                 *ngIf="arrdocdetails"
                 [responsive]="true"
                 [columns]="cols"
                 [value]="arrdocdetails.data"
                 [(selection)]="selecteditems"
                 dataKey="documentID"
                 [resetPageOnSort]="false"
                 [lazy]="false"
                 [rows]="rows"
                 [paginator]="true"
                 [autoLayout]="true"      [(first)]="first"
>
            <ng-template pTemplate="caption">
                <div class="grid col-12 pb-0" style="padding: 0px !important">
                    <div class="col-12 md:col-12 p-0">
                        <div class="grid col-12 bg-white m-0 p-0">
                            <!--<div class="col-2  align-content-center">
                                <h5 class="align-items-center pt-1 ll-2">Categories:</h5>
                            </div>-->
                            <div class="col-11 m-0 p-0">
                                <p-tabMenu [model]="distinctCatList"
                                           [scrollable]="true"
                                           [activeItem]="activeItem">
                                    <ng-template pTemplate="item" let-i>
                                        <a class="p-menuitem-link flex justify-content-between align-items-center p-3">
                                            <p-button [label]="getLabelAndCount(i)"
                                                      [raised]="true"
                                                      [rounded]="true"
                                                      [text]="i.categoryId !== selectedCategoryId"
                                                      [plain]="i.categoryId !== selectedCategoryId"
                                                      (click)="Setitem(i)"
                                                      [ngStyle]="{ width: 'max-content' }">
                                            </p-button>
                                        </a>

                                    </ng-template>
                                  
                                </p-tabMenu>

                                
                            </div>



                        </div>
                    </div>
                </div>
            </ng-template>ad
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th>View</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body"
                         let-rowData
                         let-columns="columns"
                         let-i="rowIndex">
                <tr [pSelectableRow]="rowData">
                    <td *ngFor="let col of columns">
                        <div *ngIf="
              col.header == 'Visit Date' || col.header == 'Create Date';
              then nested_object_content;
              else normal_content
            "></div>
                        <ng-template #nested_object_content>
                            {{ formatdatetime(rowData[col.field], col.header) }}
                        </ng-template>
                        <ng-template #normal_content>
                            {{ rowData[col.field] }}
                        </ng-template>
                    </td>

                    <td>
                        <button pButton
                                type="button"
                                icon="pi pi-book"
                                class="ui-button-success"
                                (click)="viewDoc(rowData)"
                                style="font-size: 0.7em"></button>
                    </td>
                </tr>
            </ng-template>
            <p-button label="Back" (click)="back()"></p-button>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">No Records found</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
      Showing {{ state.page * state.rows + 1 }} to
      {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
    </ng-template>
  </p-table>
</div>
<div [hidden]="activatedRoute.children.length === 0">
  <div class="mt-2">
    <p-button label="Back" (click)="back()"></p-button>
    <hr />
  </div>

        <router-outlet></router-outlet>
    </div>
